<template>
  <div>
    <VirtuallyMeterMap />
  </div>
</template>

<script>
import VirtuallyMeterMap from "./components/VirtuallyMeterMap";
export default {
  name: "VirtuallyFunction",
  components: {VirtuallyMeterMap},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      expressions:[],
      sum_expressions:[],
      all_expressions:[],
      all_sum_expressions:[],
      all_expressions_tree:[],
      all_sum_expressions_tree:[],
    }
  },
  mounted() {
    // this.getData();
  },
  methods:{
    getData(){
      const that=this;
      ERP.getRequest({
        url:"admin/MeterVirtually/getMeter",
        data:{
          dummy_id:that.mainObj.id,
        }
      },ret=>{
        if(ret.code){
          that.expressions=ret.data.expressions;
          that.sum_expressions=ret.data.sum_expressions;
          that.all_expressions=ret.data.all_expressions;
          that.all_sum_expressions=ret.data.all_sum_expressions;
          that.all_expressions_tree=ret.data.all_expressions_tree;
          that.all_sum_expressions_tree=ret.data.all_sum_expressions_tree;
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/components/virtually/VirtuallyFunction.vue